import AnonymousUnsubscribePage from "./pages";

export default function AnonymousUnsubscribePageRoute() {
  return <AnonymousUnsubscribePage />;
}
